// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Box from "@material-ui/core/Box";
import { DEFAULT_STATUS_TIMEOUT } from '../../../constants/configConstants';
import { toSeconds, toMilliseconds } from '../../../utils';
import ConfigItem from '../Config/ConfigItem';
import Section from '../Config/Section';

function WeatherDataExpiration() {
    return (
        <Box m={2}>
            <Section title={(
                <FormattedMessage
                    id="option.weatherDataExpiration.heading"
                    defaultMessage="Weather Data Expiration"
                />
            )}>
                <ConfigItem
                    type="number"
                    label={(
                        <FormattedMessage
                            id="statusBar.label.qnh"
                            defaultMessage="QNH"
                        />
                    )}
                    defaultValue={DEFAULT_STATUS_TIMEOUT}
                    path={['status', 'qnh', 'timeout']}
                    append="s"
                    inputFormatter={toSeconds}
                    outputFormatter={toMilliseconds}
                />
                <ConfigItem
                    type="number"
                    label={(
                        <FormattedMessage
                            id="statusBar.label.wind"
                            defaultMessage="Wind"
                        />
                    )}
                    defaultValue={DEFAULT_STATUS_TIMEOUT}
                    path={['status', 'wind', 'timeout']}
                    append="s"
                    inputFormatter={toSeconds}
                    outputFormatter={toMilliseconds}
                />
                <ConfigItem
                    type="number"
                    label={(
                        <FormattedMessage
                            id="statusBar.label.dewPoint"
                            defaultMessage="Dew point"
                        />
                    )}
                    defaultValue={DEFAULT_STATUS_TIMEOUT}
                    path={['status', 'dewPoint', 'timeout']}
                    append="s"
                    inputFormatter={toSeconds}
                    outputFormatter={toMilliseconds}
                />
                <ConfigItem
                    type="number"
                    label={(
                        <FormattedMessage
                            id="statusBar.label.temp"
                            defaultMessage="Temp"
                        />
                    )}
                    defaultValue={DEFAULT_STATUS_TIMEOUT}
                    path={['status', 'temp', 'timeout']}
                    append="s"
                    inputFormatter={toSeconds}
                    outputFormatter={toMilliseconds}
                />
            </Section>
        </Box>
    );
}

export default WeatherDataExpiration;